import { DocumentType } from '../interfaces/SignedDocument';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { useState, useEffect } from 'react';

const selectContainerStyles = (base: any) => ({
    ...base,
    minWidth: '100%',
    fontWeight: 'bold',
    color: 'var(--bs-table-active-color)',
});

const selectControlStyles = (base: any) => ({
    ...base,
    backgroundColor: 'transparent',
    border: 'none',
    '&:hover': {
        border: 'none',
    },
    '&:focus-within': {
        border: 'none',
        boxShadow: 'none',
    },
});

interface FormSelectionCardProps {
    forms: string[];
    onFormsChange: (forms: string[]) => void;
    title: string;
    selectedForms?: string[];
    disabled?: boolean;
}

const FormSelectionCard = ({ forms, onFormsChange, title, selectedForms = [], disabled = false }: FormSelectionCardProps) => {
    const { t } = useTranslation('insurance');

    const handleFormSelect = (formType: string) => {
        if (!selectedForms.includes(formType)) {
            onFormsChange([...selectedForms, formType]);
        }
    };

    const handleFormRemove = (formType: string) => {
        onFormsChange(selectedForms.filter((form) => form !== formType));
    };

    return (
        <div className="card form-selection-card">
            <div className="card-body p-0 border">
                <div className="d-flex justify-content-between align-items-center card-header">
                    <Select
                        className="w-auto"
                        onChange={(option) => option && handleFormSelect(option.value as string)}
                        value={null}
                        isDisabled={disabled}
                        placeholder={title}
                        options={forms
                            .filter((formType) => !selectedForms.includes(formType))
                            .map((formType) => ({
                                value: formType,
                                label: t(formType),
                            }))}
                        styles={{
                            container: selectContainerStyles,
                            control: selectControlStyles,
                        }}
                    />
                </div>
                <div className="selected-forms">
                    {selectedForms.map((form, index) => (
                        <div
                            key={index}
                            className="d-flex justify-content-between align-items-center border-top"
                            style={{ backgroundColor: 'white', padding: '0.85rem 0.85rem' }}
                        >
                            <span>{t(form)}</span>
                            <button className="btn btn-link p-0 border-0" onClick={() => handleFormRemove(form)} disabled={disabled}>
                                <i className="mdi mdi-close"></i>
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FormSelectionCard;
